export default __webpack_public_path__ + "media/b1dae2164c3fb86ae3aac6e0394dfd0866560bd15b00cffad61b306db23fe000.svg";